import PropTypes from 'prop-types'
import { Box, Chip } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { QR_ACTIONS } from './qrLookupApi'
import { readQrLookupConfig } from './qrLookupConfig'

/**
 * What the widget's header says about the action, beside its title (RN26).
 *
 * Only the Job detail action is labelled: the sheet is what every QR Lookup did before story 228, so
 * a label on it would tell the operator nothing, while "Opens the job" warns that a read of an order
 * jumps straight into its work. Pushed to the right edge like the header of the active job widget.
 */
const QrLookupActionChip = ({ data = {} }) => {
  const { t_ } = useSmartTranslation()
  if (readQrLookupConfig(data).action !== QR_ACTIONS.JOB_DETAIL) return null

  return (
    <>
      <Box sx={{ flexGrow: 1 }} />
      <Chip size='small' color='primary' variant='outlined' label={t_('Opens the job')} sx={{ flexShrink: 0 }} />
    </>
  )
}

QrLookupActionChip.propTypes = {
  /** The widget's saved configuration; a widget saved without `action` reads as SHEET. */
  data: PropTypes.object
}

export default QrLookupActionChip
